// src-dev/ts/components/gallery-slider.ts

export function initGallerySlider(): void {
    const slider = document.getElementById('gallerySlider');
  
    if (!slider) return;
  
    document.querySelectorAll<HTMLButtonElement>('[data-gallery-dir]').forEach(btn => {
      btn.addEventListener('click', () => {
        const direction = parseInt(btn.dataset.galleryDir ?? '0', 10) as 1 | -1;
        scroll(slider, direction);
      });
    });
  }
  
  function scroll(slider: HTMLElement, direction: 1 | -1): void {
    const isDesktop = window.innerWidth > 768;
    const scrollStep = slider.clientWidth / (isDesktop ? 2 : 1);
  
    slider.scrollBy({ left: direction * scrollStep, behavior: 'smooth' });
  }